import React from "react";
import { Button } from "components/button";
import { MoveChargesCard } from "components/MoveChargesCard";
import "./MoveCharges.scss"
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { PackingSummaryCard } from "components/PackingSummaryCard";
import { isMobile } from "core/utils";

export interface MoveChargesProps {
    onClick?(): void;
    formControl?: FormControl;
}

export interface MoveChargesState {

}

class MoveCharges extends React.Component<MoveChargesProps, MoveChargesState> {
    constructor(props: MoveChargesProps) {
        super(props);
        this.state = {};
    }
    getSignature() {
        if (this.props.onClick) {
            this.props.onClick()

        }
    }
    render() {
        return (
            <div className="todo-container">
                <div className={"paperContainer"} style={{height:window.innerHeight-150}}>
                    <div className="gap short" />
                    <div className="paperworkEst-title">
                        {/* {
                        isSuper ? <h1>Your Super deal move Details</h1>
                            : <h1>Your  Move Details</h1>
                    } */}
                        <h1> Charges & Services Details</h1>
                    </div>
                    <MoveChargesCard />
                    <PackingSummaryCard isMoveCharge={true} />
                </div>
                <div style={{ width: "100%" }}>
                    <Button
                        text={"Continue"}
                        onClick={() => this.getSignature()}
                    />
                </div>
            </div>
        );
    }
}

export default MoveCharges;